<template>
  <div>
    <b-card no-body class="py-2 px-1 container-card">
      <history-privilege-detail
        :reference="privilegeDetail.ref"
        :name-en="privilegeDetail.nameEn"
        :name-th="privilegeDetail.nameTh"
        :image-url="privilegeDetail.image"
      />
      <b-row class="mt-2 px-1">
        <b-col cols="12" class="px-2 mb-1">
          <div>
            <div class="d-flex flex-wrap justify-content-between">
              <div class="">
                <div v-if="resolveShowTabs" class="d-flex">
                  <b-button
                    class="mr-2 btn-tab-history-mode"
                    v-b-tooltip.hover
                    title="History"
                    :class="tabs == TAB_DETAIL && 'active'"
                    @click="changedTabs(TAB_DETAIL)"
                    ><icon-history
                  /></b-button>
                  <b-button
                    class="mr-2 btn-tab-history-expired"
                    v-b-tooltip.hover
                    title="History Expired"
                    :class="tabs == TAB_EXPIRED && 'active'"
                    @click="changedTabs(TAB_EXPIRED)"
                    ><feather-icon size="25" icon="AlertCircleIcon"
                  /></b-button>
                  <b-button
                    class="mr-2 btn-tab-history-mode"
                    v-b-tooltip.hover
                    title="Import Detail"
                    :class="tabs == TAB_IMPORT && 'active'"
                    @click="changedTabs(TAB_IMPORT)"
                    ><icon-import
                  /></b-button>
                  <b-button
                    class="mr-2 btn-tab-history-mode"
                    v-b-tooltip.hover
                    title="Withdraw Detail"
                    :class="tabs == TAB_EXPORT && 'active'"
                    @click="changedTabs(TAB_EXPORT)"
                  >
                    <icon-export
                  /></b-button>
                  <b-button
                    variant="primary"
                    @click="routeStockDetail('/stock')"
                    >Total Serial</b-button
                  >
                  
                </div>
              </div>
              <div
                class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-xl-2 ml-lg-1"
              >
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="resolveFields"
                :items="inventoryHistoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table normal-height"
              > -->
              <b-table
                :fields="resolveFields"
                :items="inventoryHistoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table-vertical normal-height"
              >
                <template #cell(add)="data">
                  <div>{{ data.value == 0 ? "-" : data.value }}</div>
                </template>
                <template #cell(withdraw)="data">
                  <div>{{ data.value == 0 ? "-" : data.value }}</div>
                </template>
                <template #cell(issue)="data">
                  <div>{{ data.value == 0 ? "-" : data.value }}</div>
                </template>
                <template #cell(redeem)="data">
                  <div>{{ data.value == 0 ? "-" : data.value }}</div>
                </template>
                <template #cell(void_issue)="data">
                  <div>{{ data.value == 0 ? "-" : data.value }}</div>
                </template>
                <template #cell(void_redeem)="data">
                  <div>{{ data.value == 0 ? "-" : data.value }}</div>
                </template>
                <template #cell(transfer_in)="data">
                  <div>{{ data.value == 0 ? "-" : data.value }}</div>
                </template>
                <template #cell(transfer_out)="data">
                  <div>{{ data.value == 0 ? "-" : data.value }}</div>
                </template>
                <template #cell(from_to)="data">
                  <div>
                    {{ data.item.from_to ? data.item.from_to.name : "-" }}
                  </div>
                </template>
                <template #cell(updated_by)="data">
                  <div>
                    {{ data.item.from_to ? data.item.from_to.name : "-" }}
                  </div>
                </template>
                <template #cell(progress)="data">
                  <div :class="data.value == 100 && 'color-green'">
                    {{ data.value + "%" }}
                  </div>
                </template>
                <template #cell(status)="data">
                  <div v-if="tabs == TAB_EXPIRED"
                    class="inventory-status-stock"
                    :class="resolveStockStatusClass(data.item.status)"
                  >
                    {{ resolveStockStatusLabel(data.item.status) }}
                  </div>
                  <div v-else
                    class="inventory-history-status-import"
                    :style="{
                      backgroundColor: resolveImportStatusClass(
                        data.item.status
                      ),
                    }"
                  >
                    {{ resolveImportStatusLabel(data.item.status) }}
                  </div>
                </template>
                <template #cell(status_withdraw)="data">
                  <div
                    class="inventory-history-status-import"
                    :style="{
                      backgroundColor: resolveExportStatusClass(
                        data.item.status
                      ),
                    }"
                  >
                    {{ resolveExportStatusLabel(data.item.status) }}
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex">
                    <icon-detail
                      v-if="
                        data.item.status != STATUS_PRE_PROGRESS &&
                        data.item.status != STATUS_PREPAREING
                      "
                      class="svg-icon mr-4"
                      v-b-tooltip.hover
                      title="Detail"
                      @click.native="
                        routeImportDetail('/import/' + data.item.import_id)
                      "
                    />
                    <icon-stock-detail
                      v-if="data.item.status == STATUS_SUCCESS"
                      class="svg-icon"
                      v-b-tooltip.hover
                      title="Serial Stock"
                      @click.native="
                        routeStockDetail('/stock/' + data.item.import_id)
                      "
                    />
                  </div>
                </template>
                <template #cell(actions_export)="data">
                  <b-button
                    class="mr-2 btn-tab-history-mode"
                    :class="data.item.filepath ? 'export' : ''"
                    @click="exportFile(data.item.filepath)"
                    ><icon-export
                  /></b-button>
                </template>
                <template #cell(approve_reject)="data">
                  <div class="d-flex">
                    <div
                      v-if="data.item.status == STATUS_WAIT_FOR_APPROVED"
                      class="inventory-history-import-action reject mr-4"
                      v-b-tooltip.hover
                      title="Reject"
                      @click="importReject(data.item.import_id)"
                    >
                      <icon-cancel class="svg-cancel" />
                    </div>
                    <div
                      v-if="data.item.status == STATUS_WAIT_FOR_APPROVED"
                      class="inventory-history-import-action approve"
                      v-b-tooltip.hover
                      title="Approve"
                      @click="importApprove(data.item.import_id)"
                    >
                      <icon-correct class="svg-correct" />
                    </div>
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12" class="my-1">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import ManageButton from "@/views/components/button/ManageButton.vue";
import IconDetail from "@/@core/components/svg/common/IconDetail.vue";
import IconHistory from "@/@core/components/svg/common/IconHistory.vue";
import IconImport from "@/@core/components/svg/common/IconImport.vue";
import IconStockDetail from "@/@core/components/svg/common/IconStockDetail.vue";
import IconExport from "@/@core/components/svg/inventory-history-detail/IconExport.vue";
import IconCorrect from "@/@core/components/svg/inventory-history-detail/IconCorrect.vue";
import IconCancel from "@/@core/components/svg/inventory-history-detail/IconCancel.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import HistoryPrivilegeDetail from "./components/HistoryPrivilegeDetail.vue";
import useInventoryHistoryDetail from "./hooks/useInventoryHistoryDetail";
import Upload from "@/@core/components/svg/button/Upload.vue";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    vSelect,
    ManageButton,
    IconDetail,
    HistoryPrivilegeDetail,
    IconHistory,
    IconImport,
    IconStockDetail,
    IconExport,
    IconCorrect,
    IconCancel,
    PaginationWithReorder,
    Upload,
  },
  setup() {
    const {
      TAB_DETAIL,
      TAB_IMPORT,
      TAB_EXPORT,
      TAB_EXPIRED,
      STATUS_PREPAREING,
      STATUS_PRE_PROGRESS,
      STATUS_SUCCESS,
      STATUS_WAIT_FOR_APPROVED,

      resolveFields,
      loading,
      inventoryHistoryTable,
      privilegeDetail,
      resolveShowTabs,
      tabs,
      pagination,

      routeStockDetail,
      routeImportDetail,
      changedTabs,
      resolveImportStatusLabel,
      resolveImportStatusClass,
      resolveExportStatusLabel,
      resolveExportStatusClass,
      resolveStockStatusLabel,
      resolveStockStatusClass,

      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      exportFile,
      importApprove,
      importReject,
      routeExpiredDetail,
    } = useInventoryHistoryDetail();
    return {
      TAB_DETAIL,
      TAB_IMPORT,
      TAB_EXPORT,
      TAB_EXPIRED,
      STATUS_PREPAREING,
      STATUS_PRE_PROGRESS,
      STATUS_SUCCESS,
      STATUS_WAIT_FOR_APPROVED,

      resolveFields,
      loading,
      inventoryHistoryTable,
      privilegeDetail,
      resolveShowTabs,
      tabs,
      pagination,

      routeStockDetail,
      routeImportDetail,
      changedTabs,
      resolveImportStatusLabel,
      resolveImportStatusClass,
      resolveExportStatusLabel,
      resolveExportStatusClass,
      resolveStockStatusLabel,
      resolveStockStatusClass,

      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      exportFile,
      importApprove,
      importReject,
      routeExpiredDetail,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/pages/inventory/history-privilege-detail.css";
@import '~@/assets/css/pages/inventory/history-stock-detail.css';
</style>